export enum ORIENTATION_TYPE {
  IMAGE_LEFT = 'imageLeft',
  IMAGE_RIGHT = 'imageRight',
}

export const cookieExpirationDate = new Date();
cookieExpirationDate.setMonth(cookieExpirationDate.getMonth() + 6);
